import React from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';
type Props = {
  children: React.ReactNode;
  className?: string;
};
const List = ({ className = '', children }: Props) => {
  const style = classNames(styles.list, styles[className]);
  return <div className={style}>{children}</div>;
};

const Header = ({ children }: Props) => {
  return (
    <div className={styles.listHeader}>
      <span>{children}</span>
    </div>
  );
};
const Body = ({ className = '', children }: Props) => {
  const style = classNames(styles.listBody, styles[className]);
  return <ul className={style}>{children}</ul>;
};
const Footer = ({ children }: Props) => {
  return (
    <div className={styles.listFooter}>
      <span>{children}</span>
    </div>
  );
};

List.Header = Header;
List.Body = Body;
List.Footer = Footer;

export { List };
